import { useEffect, useRef } from "react";
import { Container } from "./Section";
import { Spine } from "./Spine";

/* B11: слова зажигаются по одному, когда пересекают линию на ~65% высоты экрана.
   Яркость меняется только через opacity (B7). Слово светится, пока оно выше линии,
   поэтому прокрутка назад гасит их в обратном порядке. */
const LINES = [
  "Порядок начинается с карты.",
  "Потом цифры.",
  "Потом решение.",
  "Если наоборот, платишь дважды.",
];

export const TaglineReveal = () => {
  const root = useRef(null);

  useEffect(() => {
    const words = root.current?.querySelectorAll("[data-w]") ?? [];
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !("IntersectionObserver" in window)) {
      words.forEach((w) => (w.style.opacity = "1"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          // выше линии: внутри зоны наблюдения или уже прокручено за верх экрана
          const lit = e.isIntersecting || e.boundingClientRect.top < 0;
          e.target.style.opacity = lit ? "1" : "0.4";
        }),
      { rootMargin: "0px 0px -35% 0px" }
    );
    words.forEach((w) => io.observe(w));
    return () => io.disconnect();
  }, []);

  return (
    <Spine>
    <section className="py-28 sm:py-40" aria-label="Принцип работы">
      <Container>
        <p ref={root} className="max-w-4xl font-display text-4xl font-medium tracking-tighter sm:text-6xl lg:text-7xl">
          {LINES.map((line, i) => (
            <span key={i} className={`block ${i === LINES.length - 1 ? "text-accent-soft" : ""}`}>
              {line.split(" ").map((word, j) => (
                <span
                  key={j}
                  data-w
                  style={{ opacity: 0.4 }}
                  className="inline-block transition-opacity duration-500 ease-smooth"
                >
                  {word}
                  {" "}
                </span>
              ))}
            </span>
          ))}
        </p>
      </Container>
    </section>
    </Spine>
  );
};
